<?xml version="1.0" encoding="iso-8859-1"?>
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<path d="M394.095,330.155c-19.78-39.569-20.335-80.307-20.335-80.708v-46.08c0-64.93-52.83-117.76-117.76-117.76
			s-117.76,52.83-117.76,117.76v46.08c0,0.333-0.478,40.986-20.335,80.708c-3.968,7.936-3.541,17.357,1.118,24.909
			c4.668,7.552,12.902,12.143,21.777,12.143h65.809c-1.109,4.087-1.809,8.354-1.809,12.8c0,28.237,22.963,51.2,51.2,51.2
			s51.2-22.963,51.2-51.2c0-4.446-0.7-8.713-1.809-12.8H371.2c8.875,0,17.109-4.591,21.777-12.143
			C397.645,347.52,398.063,338.091,394.095,330.155z M256,405.606c-14.114,0-25.6-11.486-25.6-25.6c0-4.762,1.664-8.977,3.934-12.8
			h43.332c2.27,3.823,3.934,8.038,3.934,12.8C281.6,394.121,270.114,405.606,256,405.606z M140.8,341.606
			c23.04-46.08,23.04-92.16,23.04-92.16v-46.08c0-50.901,41.259-92.16,92.16-92.16c50.901,0,92.16,41.259,92.16,92.16v46.08
			c0,0,0,46.08,23.04,92.16C348.16,341.606,163.84,341.606,140.8,341.606z"/>
	</g>
</g>
<g>
	<g>
		<path d="M428.809,108.16l-21.598,13.679c17.63,27.733,27.989,60.527,27.989,95.761s-10.359,68.028-27.998,95.761L428.8,327.04
			c20.156-31.701,32-69.18,32-109.44C460.8,177.34,448.956,139.861,428.809,108.16z"/>
	</g>
</g>
<g>
	<g>
		<path d="M104.798,121.839L83.191,108.16C63.044,139.861,51.2,177.34,51.2,217.6c0,40.26,11.844,77.739,31.991,109.44
			l21.598-13.679C87.159,285.628,76.8,252.834,76.8,217.6S87.159,149.572,104.798,121.839z"/>
	</g>
</g>
<g>
	<g>
		<path d="M472.013,80.794l-21.606,13.679C473.071,130.142,486.4,172.305,486.4,217.6c0,45.295-13.329,87.458-35.994,123.127
			l21.606,13.679C497.195,314.778,512,267.93,512,217.6C512,167.27,497.195,120.422,472.013,80.794z"/>
	</g>
</g>
<g>
	<g>
		<path d="M61.594,94.473L39.987,80.794C14.805,120.422,0,167.27,0,217.6c0,50.33,14.805,97.178,39.987,136.806l21.606-13.679
			C38.929,305.058,25.6,262.895,25.6,217.6C25.6,172.305,38.929,130.142,61.594,94.473z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
